<script setup lang="ts">
import HubEmptyState from '@/modules/Workspaces/KnowledgeHub/Hubs/HubEmptyState.vue'
import PageContainer from '@/modules/Workspaces/KnowledgeHub/Layout/PageContainer.vue'
import PageTitle from '@/modules/Workspaces/KnowledgeHub/Layout/PageTitle.vue'
import PageTitleBar from '@/modules/Workspaces/KnowledgeHub/Layout/PageTitleBar.vue'

const hasFiles = false
</script>

<template>
  <PageContainer>
    <template v-if="hasFiles">
      <PageTitleBar
        v-if="hasFiles"
        class="mb-10"
      >
        <template #title>
          <PageTitle>My Hub Name</PageTitle>
        </template>
      </PageTitleBar>
    </template>
    <template v-else>
      <HubEmptyState class="flex size-full justify-center" />
    </template>
  </PageContainer>
</template>
